import React, {useContext, useEffect} from 'react'
import DemandOffersGeneralInfoService from "services/DemandOffersGeneralInfoService";
import {useParams} from "react-router";
import Loading from "components/Loading";
import GridBlock from "components/GridBlock";
import GeneralInfoBasicData from "./components/GeneralInfoBasicData";
import {connect} from "react-redux";
import GeneralInfoDocuments from "./components/GeneralInfoDocuments";
import GeneralInfoPublicAnswers from "./components/GeneralInfoPublicAnswers";
import StatisticsService from "services/StatisticsService";
import GeneralInfoRealizationAmount from "./components/GeneralInfoRealizationAmount";
import {makeStyles} from "@material-ui/core";
import scrollTo from "libs/scrollTo";
import PropTypes from "prop-types";
import PurchaserOfferContext from "context/PurchaserOfferContext";
import DemandOffersService from "services/DemandOffersService";
import {StageSections} from "../../../constants/StageSections";

const useStyles = makeStyles(theme => ({
    root: {
        marginBottom: theme.spacing(2),
        border: `solid 1px ${theme.palette.border.dark}`,
    },
    rootExpanded: {
        marginBottom: `${theme.spacing(2)}px !important`
    },
    title: {
        padding: 0,
    },
    details: {}
}));


function GeneralInfoPanel(
    {
        panelRef,
        sectionId,
        demandHeader,
        currentRfxRound,
        generalInfoBasicData,
        demandStageSectionsList
    }) {

    const classes = useStyles();
    const params = useParams();
    const demandId = params.id;
    const stageId = params.stageId;
    const section = params.section;
    const purchaserOfferContext = useContext(PurchaserOfferContext)
    const dataLoading = !generalInfoBasicData || !demandHeader || !currentRfxRound;
    useEffect(() => {
            if (!dataLoading) {
                setTimeout((elem) => scrollTo(elem), 100, panelRef.current);
            }
        }
        // eslint-disable-next-line
        , [dataLoading])

    useEffect(() => {
        DemandOffersGeneralInfoService.getContractorGeneralInfoBasicData(demandId, stageId, purchaserOfferContext?.supplierId);
        StatisticsService.getCurrentRound(demandId);
        return () => {
            DemandOffersGeneralInfoService.clearResources(DemandOffersGeneralInfoService.GENERAL_INFO_BASIC_DATA);
            StatisticsService.clearCurrentRound();
            if (demandStageSectionsList[StageSections.GENERAL_INFO]?.unreadDemandDocuments || demandStageSectionsList[StageSections.GENERAL_INFO]?.unreadRfxMessages)
                DemandOffersService.getStageSection(demandId, stageId, StageSections.GENERAL_INFO, purchaserOfferContext?.supplierId);
        }
        // eslint-disable-next-line
    }, [demandId, stageId, section])


    const panelsClassesObject = {root: classes.root, expanded: classes.rootExpanded, title: classes.title, details: classes.details}

    return dataLoading ? <Loading/> :
        <GridBlock column>
            <GeneralInfoBasicData generalInfoBasicData={generalInfoBasicData} demandHeader={demandHeader} panelsClassesObject={panelsClassesObject}/>
            <GeneralInfoDocuments panelsClassesObject={panelsClassesObject} />
            <GeneralInfoPublicAnswers currentRfxRoundId={currentRfxRound.id} panelsClassesObject={panelsClassesObject}/>
            <GeneralInfoRealizationAmount generalInfoBasicData={generalInfoBasicData} panelsClassesObject={panelsClassesObject}/>
        </GridBlock>
}

GeneralInfoPanel.propTypes = {
    sectionId: PropTypes.string.isRequired
}

export default connect((state) => ({
    demandHeader: state.resources.demandHeader,
    generalInfoBasicData: state.resources[DemandOffersGeneralInfoService.GENERAL_INFO_BASIC_DATA],
    currentRfxRound: state.resources[StatisticsService.CURRENT_RFX_RESOURCE_ID],
    demandStageSectionsList: state.resources[DemandOffersService.DEMAND_STAGE_SECTIONS_LIST]
}), {})(GeneralInfoPanel);